import useBreakPointLib from 'use-breakpoint';


type BreakpointKeys = 'xs' | 'sm' | 'md' | 'lg'

type Breakpoints = {
	[K in BreakpointKeys]: number
}

const BREAKPOINTS: Breakpoints = {
	xs:0,
	sm: 620,
	md: 1020,
	lg: 1400
};

export const useBreakpoint = (defaultBreakpoint?: BreakpointKeys) => useBreakPointLib(BREAKPOINTS, defaultBreakpoint || 'xs');
